import { emitter, Experiment, Variant } from '@marvelapp/react-ab-test';
import { ReactNode } from 'preact/compat';

import { useSelector } from '@/redux/helper';

import { ABTestProvider } from './contexts';
import { useABTestActiveVariant } from './hooks';

export const EXPERIMENT_NAME = 'default_home_page_map_vs_home_202404';
export const VARIANTS = Object.freeze({
  map: 'map',
  home: 'home',
} as const);

emitter.defineVariants(EXPERIMENT_NAME, Object.values(VARIANTS));

const LandingPageExperiment = ({ children }: { children: ReactNode }) => {
  const isLogged = useSelector((state) => state.user.logged);

  // only test for logged in users
  if (!isLogged) {
    return children;
  }

  return (
    <Experiment name={EXPERIMENT_NAME}>
      <Variant name={VARIANTS.map}>
        <ABTestProvider experiment={EXPERIMENT_NAME} variant={VARIANTS.map}>
          {children}
        </ABTestProvider>
      </Variant>
      <Variant name={VARIANTS.home}>
        <ABTestProvider experiment={EXPERIMENT_NAME} variant={VARIANTS.home}>
          {children}
        </ABTestProvider>
      </Variant>
    </Experiment>
  );
};

export const useLandingPageVariant = () => useABTestActiveVariant(EXPERIMENT_NAME) as keyof typeof VARIANTS | undefined;
export const useIsHomePageVariant = () => useLandingPageVariant() === VARIANTS.home;
export const useIsMapPageVariant = () => useLandingPageVariant() === VARIANTS.map;

export default LandingPageExperiment;
